// extracted by mini-css-extract-plugin
export default {"countdown":"Daa-z","srOnly":"Eaa-z"};